<!--身份、城市选择-->
<template>
  <div class="home" @click="switchProfession(false)">
    <div class="home_title flex">
      <div class="logo"></div>
    </div>
    <div class="home_container flex">
      <div class="identity_message">
        <!--                城市和求职意向选择-->
        <div class="choice city_choice" v-show="nowChoice!='identity'">
          <div class="choice_title">
            你期望的工作是
          </div>
          <div class="choice_tips">
            根据你的选择，我们将为你推荐最符合的模板
          </div>
          <div class="hope-item">
            <p class="blod-title">意向城市</p>
            <div class="city-list" >
              <template v-if="cityGroup && cityGroup[0] && cityGroup[0].part_cities">
                <div @click.stop="changeCity(item)" :class="['city-item', {'city-item-active': cityName == item.city_name}]" v-for="(item) in hopeCitys.list" :key="item.city_name">{{item.city_name}}</div>
              </template>
              <div class="city-item" @click.stop="choiceCity()">更多</div>
              <div v-if="!hopeCitys.names.includes(cityName)" class="city-item city-item-active" @click.stop="changeCity(cityName)">{{cityName}}</div>
            </div>
          </div>
          <!-- <div class="city_work flex">
            <div class="cities flex" @click="choiceCity()">
              <span>{{cityName}}</span>
              <div class="arrows" :class="[nowChoice=='city' ? 'active' : '']"></div>
            </div>
            <div class="works" @click.stop="switchProfession(true)">

              <div class="item" v-for="(item, index) in professionsConfirmData" :key="index">
                <div class="item-text">{{item.title}}</div>
                <div class="item-clone iconfont iconcha" @click.stop="handleCheckProfessions(item)"></div>
              </div>
              <div class="placeholder" @click="changeChoice('work')" v-if="!professionsConfirmData.length">请选择职位关键词</div>
            </div>
          </div> -->
          <div class="hope-item m-t-32">
            <p class="blod-title">意向工作类型</p>
          </div>
          <div v-show="nowChoice=='city'" :class="['flex city_work_container city-select', nowChoice=='work'||!nowChoice?'no_border':'']">
            <div class="group_title_container">
              <el-scrollbar style="height:100%">
                <div v-for="(item,index) in cityGroup" :class="['group_title',nowGroup==item.group_name?'active':'']"
                     :key="index + 'def'" @click.stop="changeCityGroup(item)">{{item.group_name}}
                </div>
              </el-scrollbar>
            </div>
            <div class="group_container">
              <el-scrollbar style="height:100%">
                <div v-for="(item,index) in cities" :class="['city_title',nowCityId == item.city_id ? 'active' : '']" :key="index + 'klm'" @click.stop="changeCity(item)">{{item.city_name}}</div>
              </el-scrollbar>
            </div>
          </div>
          <div class="flex city_work_container no_border">
            <!-- 职位类型 -->
            <div class="work_group">
              <!-- <el-scrollbar style="height:100%"> -->
                <!-- <div v-for="(item,index) in professionsTree" :key="index" class="work_name" :class="[item.checked?'active':'']" @click="handleCheckProfessions({level1Index: index, listItem:item, type:'level1'})">{{item.title}}</div> -->
                <div class="work_name" :class="[professionsConfirmData.length == 0 ? 'active':'']" @click.stop="clearAllWork()">不限</div>
                <div v-for="(item,index) in hotProfessions" :key="index + 'bcd'" class="work_name" :class="[item.checked?'active':'']" @click="handleCheckProfessions({level1Index: item.index, listItem:item, type:'level1'})">{{item.title}}</div>
                
                <div class="work_name" @click.stop="switchProfession(true)">更多</div>
                <div class="work_name active" v-for="(item, index) in hopeJobs" :key="index + 'abc'" @click.stop="handleCheckProfessions(item)">
                  {{item.title}}
                </div>
              <!-- </el-scrollbar> -->
            </div>

            <div class="professionsTree" v-if="professionState && nowChoice == 'work'" @click.stop>
              <div class="tagContent">
                <div class="level1 reset-scrollbar">
                  <div class="item" :class="[professionsOptions.level1Index === index?'active':'']" v-for="(item,index) in professionsTree" :key="index" @click="professionsOptions.level1Index = index">
                    {{item.label}}
                  </div>
                </div>
                <template v-for="(item,index) in professionsTree">
                  <div class="levels reset-scrollbar" v-if="professionsOptions.level1Index === index" :key="index">
                    <div class="list">
                      <div class="item" :class="[item.checked?'active':'']" @click="handleCheckProfessions({level1Index: index, listItem:item, type:'level1'})">{{item.title}}</div>
                    </div>

                    <template v-for="(sitem, sindex) in item.list">
                      <div :key="sindex">
                        <div class="level2"><span>{{sitem.title}}</span></div>
                        <div class="list">
                          <!-- level2 -->
                          <!-- :class="[sitem.checked?'active':'',item.checked?'disabled':'']" -->
                          <div class="item"
                            :class="[sitem.checked?'active':'']"
                            @click="handleCheckProfessions({level1Index: index, level2Index: sindex, listItem:sitem, type:'level2'})"
                          >
                            <span>{{sitem.title}}</span>
                          </div>
                          <!-- level3 -->
                          <!-- :class="[ssitem.checked ?'active':'',item.checked || sitem.checked?'disabled':'']" -->
                          <div class="item"
                            :class="[ssitem.checked ?'active':'']"
                            v-for="(ssitem, ssindex) in sitem.list" :key="ssindex"
                            @click="handleCheckProfessions({level1Index: index, level2Index: sindex, level3Index: ssindex, listItem:ssitem, type:'level3'})"
                          >
                            <span>{{ssitem.title}}</span>
                          </div>

                        </div>
                      </div>
                      
                    </template>
                    <div class="tips">
                      <p>没有找到我的意向职位</p>
                      <span class="colf6" @click="feedVisibile = !feedVisibile">立即反馈</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- <el-button class="submit_btn" @click="updateIntentions(false)">开启全新职业体验</el-button> -->
          <!-- <el-button class="ignore_btn" @click="updateIntentions('ignore')">跳过</el-button> -->

          <div class="btn-box">
            <button class="btn prev" @click="prev()">上一步</button>
            <button class="btn next" @click="updateIntentions(false)">下一步</button>
          </div>
        </div>
      </div>
    </div>
    <feedback v-if="feedVisibile" @closeFeed="feedVisibile = false" />
  </div>
</template>

<script>
	import api from '~/api'
	// import cityGroup from '@/assets/js/cities'
	import { routerTo, get_tUser } from '@/assets/js/util'
	import { Loading } from 'element-ui'
  import feedback from '@/components/jobs/feedback.vue'

	export default {
		name: 'index',
    components:{
      feedback
    },
		data () {
			return {
        feedVisibile:false,//求职意向反馈弹窗
				nowChoice: '',
				cityName: '北京',
				isSubmit: false,
				cityGroup: [],
				nowGroup: '热门城市',
				cities: [],
				nowCityId: '',
				workGroup: [],
        
        professionState:false, //是否显示职位类型
        professionsConfirmData: [],//已选择职位集合
        professionsOptions:{
          level1Index:0,
        },
        professionsTree:[], //职位类型数据集合
        hotProfessions:[{ //热门职位类型
          profession_id: 3000000,
          title: "产品",
          index: 1,
          checked:false,
        },{
          profession_id: 4000000,
          title: "运营",
          index: 2,
          checked:false,
        },{
          profession_id: 6000000,
          title: "技术",
          index: 0,
          checked:false,
        },{
          profession_id: 7000000,
          title: "设计",
          index: 3,
          checked:false,
        },{
          profession_id: 1000000,
          title: "金融",
          index: 7,
          checked:false,
        },{
          profession_id: 12000000,
          title: "教育",
          index: 12,
          checked:false,
        },{
          profession_id: 8000000,
          title: "人事行政",
          index: 6,
          checked:false,
        },{
          profession_id: 5000000,
          title: "市场公关",
          index: 4,
          checked:false,
        },{
          profession_id: 13000000,
          title: "健康医疗",
          index: 13,
          checked:false,
        },{
          profession_id: 14000000,
          title: "建筑地产",
          index: 9,
          checked:false,
        },{
          profession_id: 9000000,
          title: "销售",
          index: 5,
          checked:false,
        }]
			}
		},
		mounted () {
			this.getHotCities()
      this.getProfessionsTree();
		},
    computed: {
      hopeCitys() {
        return {
          list: this.cityGroup && this.cityGroup[0] && this.cityGroup[0].part_cities.slice(0,9) || [],
          names: this.cityGroup && this.cityGroup[0] && this.cityGroup[0].part_cities.slice(0,9).map(item => item.city_name) || []
        } 
      },
      hopeJobs() {
        let hopeHotJobsIds = this.hotProfessions.map(item => item.profession_id)
        return this.professionsConfirmData.filter(item => !hopeHotJobsIds.includes(item.profession_id) )
      }
    },
		watch: {
			professionsConfirmData: {
				deep: true,
				immediate: true,
				handler: function () {
          this.isSubmit = this.professionsConfirmData.length > 0
				}
			}
		},
		methods: {
      prev () {
        this.$router.go(-1)
      },
			// 选择城市
			choiceCity () {
				if (this.nowChoice == 'city') {
					this.nowChoice = 'work'
				} else {
					this.nowChoice = 'city'
				}
			},
      // 清空意向工作类型
      clearAllWork() {
        this.hotProfessions.forEach(item => [
          item.checked = false
        ])
        this.professionsTree.forEach(item => {
          item.checked = false
          item.list.forEach(sitem => {
            sitem.checked = false
            sitem.list.forEach(titem => {
              titem.checked = false
            })
          })
        })
        this.professionsConfirmData = [];
      },
			// 获取城市
			async getHotCities () {
				let res1 = await api.recruit.toObtainCityNew({ nums: 0, job_count: 10 })
				if (res1.code === 1000) {
					// let hotCityData = res1.data.hot_cities.map(item=>{
					//     return {id:item.city_id,adcode:item.adcode,city_name:item.city_name}
					// })
					res1.data.hot_cities.unshift({
            city_id: '',
            city_name: "全国",
            count: '',
          })
					// this.cityGroup = res1.data;
					for (let key in res1.data) {
						if (key === 'hot_cities') {
							this.cityGroup.unshift({ group_name: '热门城市', part_cities: res1.data.hot_cities })
						} else {
							this.cityGroup.push({ group_name: key, part_cities: res1.data[key] })
						}
					}
					// this.cityGroup['热门城市'] = hotCityData
					// this.cityGroup.unshift({group_name:'热门城市',part_cities:hotCityData})
					// console.log(this.cityGroup)

					this.cities = res1.data.hot_cities
					this.nowCityId = this.cities[0].city_id
					this.cityName = this.cities[0].city_name
				} else {
					this.$message.error(res1.message)
				}
			},
			// 切换城市分类(热门城市，ABCD...)
			changeCityGroup (obj) {
				this.cities = obj.part_cities
				this.nowGroup = obj.group_name
			},
			// 切换城市
			changeCity (obj) {
        // 反选
        if(obj == this.cityName) {
          this.cityName = '全国'
          this.nowCityId = null
        } else {
          this.nowCityId = obj.city_id || null
          this.cityName = obj.city_name
        }
				this.nowChoice = 'work'
			},
			// 切换选择城市和职能
			changeChoice (state) {
				this.nowChoice = state
			},
			// 更新求职意向信息/跳过设置
			updateIntentions (state) {
        if(this.professionState){
          this.professionState = false;
          return
        }
				let data = {}
				if (!state) {
					data = {
            city_ids: this.nowCityId ? [ this.nowCityId ] : [],
            profession_full_ids: this.professionsConfirmData.map(item => item.profession_id).flat(Infinity),
          }
				}
        if (data.city_ids.length == 0 && data.profession_full_ids.length == 0) {
          // routerTo('/cvs')
          routerTo('/onboading/select-company')
          return
        }
				api.identity.updateInten(data).then((res) => {
					if (res.code === 1000) {
						// routerTo('/cvs')
            routerTo('/onboading/select-company')
					} else if (res.code === 2001) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						window.location.href = window.location.origin + '/auth-signin/?type=login'
					} else {
						this.$message({
							type: 'warning',
							message: res.message
						})
					}
				})
      },
      // 切换是否显示职位类型
      switchProfession(state){
        this.professionState = state
        if(!state){
          this.nowChoice = ''
        } else {
          this.nowChoice = 'work'
        }
      },
      //选择职业事件
      handleCheckProfessions({level1Index, level2Index, level3Index, listItem, type,}) {
        if(type==='level1'){
          //查找当前是否已经选中
          let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
          //查找当前大分类中是否有已经选中的
          let hasCurrentLevel = this.professionsConfirmData.findIndex(item=> item.level1Index === level1Index);
          if(checkIndex>-1){
            //反选
            this.professionsConfirmData.splice(checkIndex,1);
            this.professionsTree[level1Index].checked = false;
          }else if(this.professionsConfirmData.length === 3 && hasCurrentLevel===-1){
            this.$message.warning("最多选择三个")
            return
          }else{
            this.professionsTree[level1Index].checked = true;
            // 向下清除选中状态(2/3级)
            this.professionsTree[level1Index].list.forEach((sitem,sindex)=>{
              let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === sitem.profession_id);
              if(levelIndex>-1){
                this.professionsConfirmData.splice(levelIndex,1);
              }
              sitem.checked = false;
              sitem.list.forEach(ssitem=>{
                let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === ssitem.profession_id);
                if(levelIndex>-1){
                  this.professionsConfirmData.splice(levelIndex,1);
                }
                ssitem.checked = false;
              })
            })
            //添加
            this.professionsConfirmData.push({
              title: listItem.title,
              profession_id: listItem.profession_id,
              listItem,
              type,
              level1Index
            })
          }
        }else if(type === 'level2'){
          // 查找当前一级分类是否选中
          // if(this.professionsTree[level1Index].checked){
          //   return
          // }
          //查找当前是否已经选中
          let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
          //查找当前大分类/小模块中是否有已经选中的
          let hasCurrentLevel = this.professionsConfirmData.findIndex(item=> item.level1Index === level1Index && item.level2Index === level2Index);

          if(checkIndex>-1){
            //反选
            this.professionsConfirmData.splice(checkIndex,1);
            this.professionsTree[level1Index].list[level2Index].checked = false;
          }else if(this.professionsConfirmData.length === 3 && hasCurrentLevel===-1){
            this.$message.warning("最多选择三个")
            return
          }else{
            this.professionsTree[level1Index].list[level2Index].checked = true;
            // 向下清除选中状态（3级）
            this.professionsTree[level1Index].list[level2Index].list.forEach((sitem,sindex)=>{
              let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === sitem.profession_id);
              sitem.checked = false;
              if(levelIndex>-1){
                this.professionsConfirmData.splice(levelIndex,1);
              }
            })
            // 向上清除选中状态 (1级)
            let topItem = this.professionsTree[level1Index]
            let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === topItem.profession_id);
            topItem.checked = false;
            if(levelIndex>-1){
              this.professionsConfirmData.splice(levelIndex,1);
            }
            //添加
            this.professionsConfirmData.push({
              title: listItem.title,
              profession_id: listItem.profession_id,
              listItem,
              type,
              level1Index,
              level2Index,
            })
          }
        }else if(type === 'level3') {
          // if(this.professionsTree[level1Index].checked || this.professionsTree[level1Index].list[level2Index].checked){
          //   return
          // }
          // 向上清除选中状态 (1级)
          let topItem = this.professionsTree[level1Index]
          let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === topItem.profession_id);
          topItem.checked = false;
          if(levelIndex>-1){
            this.professionsConfirmData.splice(levelIndex,1);
          }
          // 向上清除选中状态 (2级)
          let level2Item = this.professionsTree[level1Index].list[level2Index]
          let targetLevel2Index = this.professionsConfirmData.findIndex(item=> item.profession_id === level2Item.profession_id);
          if(targetLevel2Index>-1){
            this.professionsConfirmData.splice(targetLevel2Index,1);
          }
          level2Item.checked = false;
          
          //查找当前是否已经选中
          let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
          if(checkIndex>-1){
            //反选
            this.professionsConfirmData.splice(checkIndex,1);
            this.professionsTree[level1Index].list[level2Index].list[level3Index].checked = false;
          }else if(this.professionsConfirmData.length === 3){
            this.$message.warning("最多选择三个")
            return
          }else{
            this.professionsTree[level1Index].list[level2Index].list[level3Index].checked = true;
            
            //添加
            this.professionsConfirmData.push({
              title: listItem.title,
              profession_id: listItem.profession_id,
              listItem,
              type,
              level1Index,
              level2Index,
              level3Index,
            })
          }
        }

        this.hotProfessions.forEach(item=>{
          let checkedState = this.professionsConfirmData.findIndex(sitem => sitem.profession_id === item.profession_id);
          console.log(checkedState)
          item.checked = checkedState>=0
        })
        
      },
      //获取树形结构的职位类型
      getProfessionsTree(){
        api.staticApi.getProfessionsTree().then(res=>{
          if(res.code === 1000){
            res.data.forEach((item,index)=>{
              item.title = `全部${item.title}`
              item.checked = false;
              
              // 去除 其他开头的职位
              item.list = item.list.filter((filterItem, filterIndex) => !filterItem.title.startsWith('其他'))

              // level2
              item.list.forEach((sitem,sindex)=>{
                sitem.title = `全部${sitem.title}`
                sitem.checked = false;
                
                // level3
                sitem.list.forEach((ssitem, ssindex)=>{
                  ssitem.checked = false;
                })

              })

            })
            this.professionsTree = res.data
          }
        })
      },
		}
	}
</script>

<style lang="scss">
  html, body, #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  .works {
    width: 224px;
    height: 100%;
    margin-left: 15px;
    overflow: hidden;
    .el-input {
      .el-input__inner {
        line-height: 39px;
        border: none !important;
      }
    }
  }
  .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
  .group_container {
    .el-scrollbar {
      .el-scrollbar__wrap {
        .el-scrollbar__view {
          width: 100%;
          height: 100%;
          display: flex !important;
          flex-wrap: wrap;
          /*margin-left: 10px!important;*/
          /*justify-content: space-around!important;*/
          align-content: flex-start !important;
        }
      }
      .el-scrollbar__bar.is-vertical > div {
        width: 0 !important;
      }
    }
  }
  .group_title_container {
    .el-scrollbar {
      .el-scrollbar__wrap {
        .el-scrollbar__view {
          width: 100%;
          height: 100%;
          display: flex !important;
          flex-wrap: wrap;
          /*margin-left: 10px!important;*/
          /*justify-content: space-around!important;*/
          align-content: flex-start !important;
        }
      }
      .el-scrollbar__bar.is-vertical > div {
        width: 0 !important;
      }
    }
  }
  .work_group {
    .work_name {
      height: 28px;
      line-height: 28px;
      // margin: 16px 10px 0 0;
      padding: 0 20px;
      border-radius: 15px;
      border: 1px solid #ececec;
      color: #9c9c9c;
      cursor: pointer;
      &.active, &:hover {
        border-color: #FF6644;
        color: #FF6644;
      }
    }
    .el-scrollbar {
      .el-scrollbar__wrap {
        .el-scrollbar__view {
          // width: 416px;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import './jobs_intention.scss'
</style>
